import { createAction } from "redux-actions";
import { GET_AGREEMENTS_BY_INSTITUTION } from "../constants";
import { feathersCreateData } from "../services";
import { encrypt } from '../functions/mobile';

const sendData = encrypt(JSON.stringify({
    access : "GET_AGREEMENTS_BY_INSTITUTION",
    channel : "WEB"
}))
export const getAgreementsSwitchServices = createAction(GET_AGREEMENTS_BY_INSTITUTION, () => feathersCreateData('switch-services',{
    sendData
})())